import { useEffect, useState } from 'react';
import { Button, ButtonGroup, Grid, makeStyles } from '@material-ui/core';
import { Card } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        border: '2px solid #fbfbfb',
        Opacity: 0.9,
        minWidth: 110,
        padding: '5px 0px', // margin: 3,
        borderRadius: 7,
        background: '#fbfbfb'
    }
}));
const MapQCHeaderUnits = (props) => {
    const classes = useStyles();

    const ConvertOps = (ops) => {
        return ops?.map((op) => {
            return {
                ...op,
                type: `${op[props.valuePropertyName || 'type']}`,
                name: `${op[props.textPropertyName || 'name']}`
            };
        });
    };

    const [state, setState] = useState({
        ButtonList: ConvertOps(props.ButtonList) || []
    });

    useEffect(() => {
        props.ButtonList && setState((st) => ({ ...st, ButtonList: ConvertOps(props.ButtonList) }));
    }, [props.ButtonList]);
    let totalpassFaild = props.List[props.hourType]?.totalPassed + props.List[props.hourType]?.totalFailed;
    let totalper = (props.List[props.hourType]?.totalPassed / totalpassFaild) * 100;
    let percentage = totalper.toFixed(2);
    return (
        <Card className={classes.root}>
            <Grid container justifyContent="space-between">
                <Grid item xs={12} sm={6} style={{ float: 'right' }}>
                    <div style={{ width: '100%', textAlign: 'left', color: '#f50057', fontWeight: 600, margin: '10px 20px' }}>
                        <ButtonGroup color="secondary" aria-label="outlined primary button group" size="small">
                            {state.ButtonList.map((btn) => {
                                return (
                                    <Button
                                        variant={props.hourType === btn.type ? 'contained' : 'outlined'}
                                        onClick={() => props.handleBar(btn.type)}
                                        style={{ fontSize: 10 }}
                                    >
                                        {btn.name}&nbsp;-&nbsp;<b> {btn.percentage ? `${btn.percentage}%` : 'N/A'}</b>
                                    </Button>
                                );
                            })}
                        </ButtonGroup>
                    </div>
                </Grid>
            </Grid>

            <div style={{ padding: '0px 18px' }}>
                <hr
                    style={{
                        flexShrink: 0,
                        borderWidth: '0px 0px thin',
                        borderStyle: 'solid',
                        borderColor: 'rgba(58, 53, 65, 0.12)'
                    }}
                />
            </div>
            <Grid container spacing={1} style={{ padding: '0px 18px' }}>
                {props.List[props.hourType] && props.List[props.hourType].length ? (
                    <>
                        {props.List[props.hourType]?.map((m) => {
                            let total = m.qcFailed + m.qcPassed;
                            return (
                                <Grid item sm={4} lg={3} style={{ padding: '10px 10px' }}>
                                    <div
                                        style={{
                                            borderLeft: '3px solid #00F433',
                                            padding: '5px 10px 0px 10px',
                                            width: '100%'
                                        }}
                                    >
                                        <div
                                            style={{
                                                paddingBottom: 10,
                                                textAlign: 'left'
                                            }}
                                        >
                                            <span style={{ fontSize: 13, marginBottom: 10 }}>{m[props.render]}</span>
                                            <div>
                                                <>Failed:&nbsp;</>
                                                <span style={{ fontSize: 30, fontWeight: 600 }}>{m.qcFailed}</span>/{total}
                                                <>&nbsp;Passed:&nbsp;</>
                                                <span style={{ fontSize: 30, fontWeight: 600 }}>{m.qcPassed}</span>/{total}
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                            );
                        })}
                    </>
                ) : (
                    <b style={{ padding: '35px 35px' }}>No Records</b>
                )}
            </Grid>
        </Card>
    );
};

export default MapQCHeaderUnits;
